/*
* jquery-backgroundMove master by sameera liyanage
* License MIT
$('element').backgroundMove();
*/
if ($(window).width() > 600) {
  (function ($) {
    $.fn.backgroundMove = function (options) {
      var defaults = {movementStrength: '50'};
      options = $.extend(defaults, options);
      var $this = $(this);

      var movementStrength = options.movementStrength;
      var height = movementStrength / $(window).height();
      var width = movementStrength / $(window).width();
      $('.hero-section, .top-menu, .clients').mousemove(function (e) {
        var pageX = e.pageX - ($(window).width() / 2);
        var pageY = e.pageY - ($(window).height() / 2);
        var newvalueX = width * pageX;
        var newvalueY = height * pageY * 0.4;
        //$this.css('background-position', newvalueX + 'px     ' + newvalueY + 'px');
        $this.css('background-position', 'calc(50% + ' + newvalueX + 'px)' + ' calc(40% + ' + newvalueY + 'px)');
      });

    }
  })(jQuery);

  (function ($) {
    $.fn.shadowMove = function (options) {
      var defaults = {movementStrength: '50'};
      options = $.extend(defaults, options);

      var $this = $(this);

      var movementStrength = options.movementStrength;
      var height = movementStrength / $(window).height();
      var width = movementStrength / $(window).width();
      $('.hero-section, .top-menu, .clients').mousemove(function (e) {
        var pageX = e.pageX - ($(window).width() / 2);
        var pageY = e.pageY - ($(window).height() / 2);
        var newvalueX = width * pageX;
        var newvalueY = height * pageY;
        //$this.css('background-position', newvalueX + 'px     ' + newvalueY + 'px');
        $this.css('left', 'calc(50% + ' + newvalueX + 'px)');
        if (newvalueY < 0) {
          $this.css('width', 'calc(50vh + ' + (-2 * newvalueY) + 'px - 60px)');
          $this.css('filter', 'blur(' + (14 + (-0.1 * newvalueY)) + 'px)');
//				$this.css('opacity', (0.4 + (0.002 * newvalueY)));
        } else {
          $this.css('filter', 'blur(' + (14 + (-0.1 * newvalueY)) + 'px)');
//				$this.css('opacity', (0.4 + (0.002 * newvalueY)));
        }
      });

    }
  })(jQuery);
}



// WEBPACK FOOTER //
// ./scripts/libraries/jquery.backgroundMove.js